import Vue from 'vue'
import { /* mapGetters, */ mapMutations } from 'vuex'

const mixins = Vue.mixin({
  // computed: {
  //   ...mapGetters([])
  // },
  methods: {
    ...mapMutations(['setProgress'])
  }
})

export default mixins